import DropDown from "@components/Dropdown";
import { Row } from "@components/Layout";
import Location from "@components/Location";
import UserIcon from "@components/UserIcon";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import useSignOut from "@hooks/useSignOut";
import { notificationsContext } from "@layouts/App/context/Notifications";
import { userContext } from "@layouts/App/context/User";
import { A, useNavigate } from "@solidjs/router";
import { AiOutlineBell } from "solid-icons/ai";
import { BsEyeglasses, BsLightning } from "solid-icons/bs";
import { FaRegularBookmark, FaSolidArrowRightFromBracket, FaSolidRightToBracket, FaSolidUser } from "solid-icons/fa";
import {
	IoChatbubblesOutline,
	IoHomeOutline,
	IoLocationOutline,
	IoMicOutline,
	IoSettingsOutline,
} from "solid-icons/io";
import { OcPeople3, OcPerson3 } from "solid-icons/oc";
import { Show, type VoidComponent, useContext } from "solid-js";
import MenuItem from "../MenuItem";
import type { ControlsProps } from "../Sidebar/components/Controls/types";
import IconButton from "./IconButton";
import { MobileNavbarWrapper, NavItemsRow, OpenNavbarIcon, OpenSidebarIcon } from "./styled";

const MobileNavbar: VoidComponent<
	{ onNavbarOpen: () => void; onSidebarOpen?: () => void; public?: boolean } & Partial<ControlsProps>
> = (props) => {
	const { user } = useContext(userContext);
	const { notifications } = useContext(notificationsContext);
	const navigate = useNavigate();
	const { t } = useI18n();
	const signout = useSignOut();
	return (
		<MobileNavbarWrapper alignItems="center" justifyContent="space-between" padding="0 20px">
			<OpenNavbarIcon onclick={props.onNavbarOpen} font-size="35px" />
			<Show
				when={props.public}
				fallback={
					<>
						<NavItemsRow w="max-content">
							<MenuItem href="/home" icon={<IoHomeOutline size={30} />} />
							<MenuItem href="/create" icon={<IoMicOutline size={30} />} />
							<MenuItem href={`/profile/${user.uid}`} icon={<OcPerson3 size={25} />} />
							<MenuItem href="/discover/*" icon={<BsEyeglasses size={30} />} />
							<MenuItem href="/groups" icon={<OcPeople3 size={25} />} />
							<MenuItem href="/bookmarks/*" icon={<FaRegularBookmark size={25} />} />
						</NavItemsRow>
						<Row w="max-content" alignItems="center" gap="10px">
							<DropDown
								items={[
									{ label: t("app.nav.history"), icon: <IoChatbubblesOutline />, onClick: () => navigate("/history") },
									{
										label: t("app.nav.settings"),
										icon: <IoSettingsOutline />,
										onClick: () => navigate("/settings"),
									},
									{ label: t("app.nav.logout"), icon: <FaSolidArrowRightFromBracket />, onClick: signout },
								]}
							>
								<UserIcon diameter="40px" src={user.photo} />
							</DropDown>
							<A href="/notifications">
								<IconButton dot={notifications.notificationsUnread > 0}>
									<AiOutlineBell font-size="20px" font-weight="bold" />
								</IconButton>
							</A>
							<A href="/chat">
								<IconButton dot={notifications.chatUnread > 0}>
									<IoChatbubblesOutline font-size="20px" font-weight="bold" />
								</IconButton>
							</A>
							<Location
								onDrag={props.onLocationDrag}
								tracklists={props.locationTracklists}
								onBookmark={(uuid) => props.handleLocationChange?.(uuid, "bookmarked", "bookmark_count")}
								onLike={(uuid) => props.handleLocationChange?.(uuid, "liked", "rating")}
							>
								<IconButton>
									<IoLocationOutline font-size="20px" font-weight="bold" />
								</IconButton>
							</Location>
							<IconButton style={{ filter: "blur(3px)" }}>
								<BsLightning font-size="20px" font-weight="bold" />
							</IconButton>
							<Show when={props.onSidebarOpen}>
								<OpenSidebarIcon onclick={props.onSidebarOpen} font-size="35px" />
							</Show>
						</Row>
					</>
				}
			>
				<NavItemsRow w="max-content">
					<MenuItem href="/auth/login" icon={<FaSolidRightToBracket size={25} />} />
					<MenuItem href="/auth/register" icon={<FaSolidUser size={25} />} />
				</NavItemsRow>
			</Show>
		</MobileNavbarWrapper>
	);
};
export default MobileNavbar;
